import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { mobileAnalyticsApi } from "../../services/mobileAnalyticsApi";
import { Card } from "../../components/common/Card";
import { Spinner } from "../../components/common/Spinner";
import { GapNotice } from "../../components/common/GapNotice";

export function MobileAnalyticsPage() {
  const [voiceUsage, setVoiceUsage] = useState(null);

  useEffect(() => {
    mobileAnalyticsApi.voiceCommandUsage().then((r) => setVoiceUsage(r.commands)).catch(() => setVoiceUsage(null));
  }, []);

  return (
    <div>
      <h1>Mobile Analytics</h1>

      <Card title="Voice Command Usage" className="section-spacing">
        {voiceUsage === null ? (
          <GapNotice>
            The only mostly-real section on this page: app.VoiceCommandLogs (V014) is already populated by
            api/functions/voice.py, this just needs a GROUP BY interpreted_action admin endpoint -- low-risk to add
            compared to the rest of this page.
          </GapNotice>
        ) : voiceUsage.length === 0 ? (
          <p style={{ color: "var(--color-text-muted)" }}>No voice commands logged yet.</p>
        ) : (
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={voiceUsage}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="interpreted_action" angle={-20} textAnchor="end" height={70} />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#f2a900" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </Card>

      <Card title="App Version Adoption" className="section-spacing">
        <GapNotice>Mobile has no version-reporting telemetry -- app.json's version isn't sent to the server anywhere.</GapNotice>
      </Card>
      <Card title="Crash Rates by Device/OS" className="section-spacing">
        <GapNotice>No crash-reporting SDK is wired into mobile/package.json (no Sentry/App Center/Crashlytics) and no backend table to receive reports.</GapNotice>
      </Card>
      <Card title="Offline Sync Success Rates" className="section-spacing">
        <GapNotice>mobile/src/services/syncEngine.js doesn't report its own success/failure counts back to the server.</GapNotice>
      </Card>
      <Card title="Push Notification Delivery Rates" className="section-spacing">
        <GapNotice>app.DeviceTokens (added in the V026 gap-closure pass) stores tokens now, but nothing tracks whether a given push was actually delivered or opened.</GapNotice>
      </Card>
      <Card title="Watch App Usage" className="section-spacing">
        <GapNotice>Moot until a watch companion app exists -- flagged as not React-Native-feasible during the mobile build (needs a separate native watchOS/Wear OS project).</GapNotice>
      </Card>
      <Card title="Biometric Auth Usage">
        <GapNotice>mobile/src/services/biometricService.js never reports whether biometric unlock succeeded/was used back to the server.</GapNotice>
      </Card>
    </div>
  );
}
